import { ReactComponent as ArrowUp } from '../../assets/svgs/arrowup.svg'
import './BackToTop.scss'

const BackToTop = () => (
  <button
    type="button"
    className="a-back-to-top"
    onClick={() => window.scrollTo(0, 0)}>
    <ArrowUp className="a-back-to-top__icon" />
    <span>Back to top</span>
  </button>
)

export default BackToTop
